/********* --- Rich Banner Text --- *********/
class RichBannerTextSection extends BTSection {
  onInit() {
    const effect = BT.data.cacheWindowWidth < BT.options.windowScreen.desktop ? false : true;
    if(!Shopify.designMode) {
      const timeout = BT.data.cacheWindowWidth < BT.options.windowScreen.desktop ? 2300 : 0;
      setTimeout(() => {
        this.runSliderBanner(effect);
      }, timeout);
    } else {
      this.runSliderBanner(effect);
    }
    BT.initDealCountdown(this.container);
    
    this.slider = this.container.find(BT.getSliderSelector());
  }

  runSliderBanner(effect) {
    this.container.find('.zoom-fade.lazyloaded').addClass('ignore-effect');
    BT.initSlider(this.container, true, effect);
  }

  onBlockSelect(evt) {
    var ele = $(evt.target);
    if(ele.attr('data-slick-index') != undefined) {
      this.slider.slick('slickGoTo', ele.attr('data-slick-index'), true).slick('slickPause');
      }
    }

  onBlockDeselect() {
    // Resume auto-rotate
    if(this.slider.hasClass('slick-initialized')) {
      this.slider.slick('slickPlay');
    }
  }
  onUnload() {
    BT.destroySlider(this.container);
    BT.destroyDealCountdown(this.container);
  }
}
theme.sections.constructors['rich-banner-text'] = RichBannerTextSection;